import http from "./helpers/httpInterceptor";
const state = () => ({
  abnormalList: [],
  editAbnormalData: {},
  listNotification: {},
  updateNotification: {},
  createExplanation: {},
  dataStatusUpdated: {},
  dataActual: [],
  updateJobAbnormal: [],
  dataActualFixed: [],
});

// mutations
const mutations = {
  ABNORMAL_CASE_DATA(states, data) {
    states.abnormalList = data;
  },
  EDIT_ABNORMAL_DATA(states, data) {
    states.editAbnormalData = data;
  },
  GET_LIST_NOTIFICATION(states, data) {
    states.listNotification = data;
  },
  READ_NOTIFICATION(states, data) {
    states.updateNotification = data;
  },
  CREATE_ABNORMAL_DATA(states, data) {
    states.createExplanation = data;
  },
  UPDATE_ABNORMAL_STATUS_DATA(states, data) {
    states.dataStatusUpdated = data;
  },
  ACTUAL_SELECTIONS(states, data) {
    states.dataActual = data;
  },
  UPDATE_ABNORMAL(states, data) {
    states.updateJobAbnormal = data;
  },
  GET_ACTUAL_OF_FIXED(states, data) {
    states.dataActualFixed = data;
  },
};

// actions
const actions = {
  createExplanation({ commit }, payload) {
    return http
      .post(`/tms/request-management/create-explanation/${payload.id}`, payload.data)
      .then((res) => {
        commit("CREATE_ABNORMAL_DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createExplanationFlexible({ commit }, payload) {
    return http
      .post(`/tms/request-management/create-explanation`, payload.data)
      .then((res) => {
        commit("CREATE_ABNORMAL_DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAbnormalCaseData({ commit }, url) {
    return http
      .get("/tms/abnormal-case/" + url)
      .then((res) => {
        commit("ABNORMAL_CASE_DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateAbnormalCaseData({ commit }, payload) {
    return http
      .put(`/tms/request-management/edit-explanation/${payload.id}`, payload.data)
      .then((res) => {
        commit("EDIT_ABNORMAL_DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getListNotification({ commit }) {
    return http
      .get("/tms/notifications?page=1&size=5")
      .then((res) => {
        commit("GET_LIST_NOTIFICATION", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  readNotification({ commit }, payload) {
    return http
      .put(`/tms/notifications/${payload.id}`)
      .then((res) => {
        commit("READ_NOTIFICATION", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getParamsDataToSelectActual({ commit }) {
    return http
      .get("/tms/abnormal-case/actual")
      .then((res) => {
        commit("ACTUAL_SELECTIONS", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateStatusAbnormal({ commit }, payload) {
    return http
      .put(`/tms/request-management/update-status-explanation/${payload.id}`, payload.data)
      .then((res) => {
        commit("UPDATE_ABNORMAL_STATUS_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateJobAbnormal({ commit }, payload) {
    return http
      .delete(`/tms/abnormal-case/rerun-abnormal-case?date=${payload.date}&employee=${payload.employee}`, payload)
      .then((res) => {
        commit("UPDATE_ABNORMAL", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getActualOfFixed({ commit }) {
    return http
      .get(`tms/abnormal-case/get-actual-fixed-schedule`)
      .then((res) => {
        commit("GET_ACTUAL_OF_FIXED", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  createExplanationV2(_, payload) {
    return http
      .post(`/tms/request-management/create-explanation-request`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateExplanationV2(_, payload) {
    return http
      .put(`/tms/request-management/edit-explanation-request`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateStatusExplanationV2(_, payload) {
    return http
      .put(`/tms/request-management/update-status-explanation-request`, payload.data)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
